interface LegalLinksProps {
  termsText: string
  termsOfService: string
  privacyPolicy: string
  dataDeletionAgreement: string
  andText: string
  openInNewTab?: boolean
}

export function LegalLinks({
  termsText,
  termsOfService,
  privacyPolicy,
  dataDeletionAgreement,
  andText,
  openInNewTab = false,
}: LegalLinksProps) {
  const target = openInNewTab ? "_blank" : undefined

  return (
    <div className="text-muted-foreground *:[a]:hover:text-primary text-center text-xs text-balance *:[a]:underline *:[a]:underline-offset-4">
      {termsText}{" "}
      <a href="/terms-of-service" target={target} rel="noopener noreferrer">
        {termsOfService}
      </a>
      ,{" "}
      <a href="/privacy-policy" target={target} rel="noopener noreferrer">
        {privacyPolicy}
      </a>
      , {andText}{" "}
      <a href="/data-deletion-agreement" target={target} rel="noopener noreferrer">
        {dataDeletionAgreement}
      </a>
      .
    </div>
  )
}
